import Layout from "./Layout";
import RequestMaterial from "../components/RequestMaterial.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function RequestMaterialPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <RequestMaterial></RequestMaterial>
        </Layout>
      )}
      {/* Add a loader or handle unauthorized access */}
    </>
  );
}

export default RequestMaterialPage;
